<template>
	<SmartLayoutC compId="home_wrapper" mode="basic" />
</template>

<script>
export default {
	name: 'DynamicHome'
};
</script>
<script setup>
import SmartLayoutC from '@/view/enterprise_rebuild/components/SmartLayoutC.vue';
import { IrstoreTracker as IrTrack } from '@/utils/tracker';
import { onMounted } from 'vue';
import { resolveStoreId, resolvePageId } from '@rebuild/utils/context';

const addViewTrack = () => {
	IrTrack.send({
		curPage: '投资者关系专栏',
		content: '浏览页面',
		event: 'VIEW',
		module: '投资者关系专栏',
		params: {
			'浏览模块名称': '首页',
			'浏览模块类型': '系统默认模块',
			'企业ID': resolveStoreId(),
			'页面ID': resolvePageId()
		}
	});
};

onMounted(() => {
	addViewTrack();
});
</script>
